import {translations} from 'locales/translations';
import {__} from 'utils/messages';

export default {
  product: () => __(translations.commercialDocumentComponents.product, 'Product'),
};
